<div class="container-carousel">
  <navaar-header [title]="title" [show-back-icon]="true">
    <span (click)="showSortList()" slot=custom-icon class="icon-sort-button">
      <navaar-sort-icon></navaar-sort-icon>
    </span>
  </navaar-header>
  <navaar-carousel-library (onPaginate)="paginate($event)"
                           [isEnd]="isEnd"
                           [items]="items"
                           [is-direct-play]="true"
                           [disable-when-fetch-data]="isLoading"
                           [page-size]="PAGE_SIZE"
                           [total]="total"
                           [(pageNo)]="pages"
                           [tab]="tabNameContextMenu"
  ></navaar-carousel-library>
</div>

<ng-container *ngIf="isShowContextMenu">
  <div class="container-context-menu">
    <div class="wrapper-context-menu"
         [@slide]="slideAnimationPopup"
         (@slide.done)="onSlidePopupAnimation($event)">
      <ul>
        <li class="caption-sort"><span>مرتب سازی بر اساس</span>
          <navaar-sort-icon [color]="'#00CDFF'"></navaar-sort-icon>
        </li>
        <ng-template ngFor [ngForOf]="sortItems" let-item>
          <li (click)="selected(item)"><span [class.isActive]="item.isSelected" [textContent]="item.title"></span></li>
        </ng-template>

      </ul>
    </div>
    <div class="overlay" (click)="isShowContextMenu = false"></div>
  </div>
</ng-container>
